export default "__VITE_ASSET__8c9fa782__"